import { render, staticRenderFns } from "./SurveyButton.vue?vue&type=template&id=6ec6cf04&scoped=true&"
import script from "./SurveyButton.vue?vue&type=script&lang=ts&"
export * from "./SurveyButton.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyButton.vue?vue&type=style&index=0&id=6ec6cf04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6cf04",
  null
  
)

export default component.exports